module.exports = __webpack_public_path__ + "media/images/company/cp20-578eca8781dfb1357fabb564b4b2cd7f.png";